import React from "react";
import {connect} from "react-redux";

import LookListFeature from "../../lookNavigation/lookMain/lookListFeature/lookListFeature";

const LookAllWallsTutorialHighlightFeature = (props) => {

  const {lookAllWallsTutorial} = props;
  const {left, top, height, lookFeature} = lookAllWallsTutorial;

  let style = {
    position: "fixed",
    left,
    top,
    height,
  }

  return <LookListFeature style={style}
                          isAllWallsTutorialItem={true}
                          lookFeature={lookFeature}
                          navItems={[]}/>
};

const mapStateToProps = (store) => {
  const {lookAllWallsTutorial, lookViewType} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookAllWallsTutorial,
    lookViewType,
    isMobile,
  };
};

export default (
  connect(mapStateToProps)(LookAllWallsTutorialHighlightFeature)
)
